import { CircleAlert, CircleCheck, Info, TriangleAlert } from 'lucide-react'
import { Toaster as Sonner } from 'sonner'

export { toast } from 'sonner'

export interface ToasterProps {
  dir: 'ltr' | 'rtl'
  theme: 'light' | 'dark' | 'system'
  regionLabel: string
}

/** Toasts repeat the verb of the action ("Customer archived"); they sit at the bottom end corner. */
export function Toaster({ dir, theme, regionLabel }: ToasterProps) {
  return (
    <Sonner
      dir={dir}
      theme={theme}
      position={dir === 'rtl' ? 'bottom-left' : 'bottom-right'}
      containerAriaLabel={regionLabel}
      icons={{
        success: <CircleCheck className="size-4 text-ink-green" />,
        error: <CircleAlert className="size-4 text-ink-red" />,
        warning: <TriangleAlert className="size-4 text-ink-amber" />,
        info: <Info className="size-4 text-stamp" />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'flex w-full items-start gap-2.5 rounded-panel border border-rule overlay px-3.5 py-3 text-sm text-ink sm:w-[356px]',
          icon: 'mt-0.5 flex shrink-0',
          content: 'flex min-w-0 flex-1 flex-col gap-0.5',
          title: 'font-medium',
          description: 'text-ink-muted',
          actionButton:
            'ms-2 h-7 shrink-0 rounded-sm border border-rule-strong bg-surface px-2.5 text-sm font-medium text-ink hover:bg-surface-sunken',
        },
      }}
    />
  )
}
